import WorkReportConstants from '../constants/work-report-constants';
import dailyReportService from '../services/WorkReport/daily-report-service';
import weeklyReportService from '../services/WorkReport/weekly-report-service';
import monthlyReportService from '../services/WorkReport/monthly-report-service';
import templateManagementService from '../services/WorkReport/template-management-service';
// import { message } from 'antd';

const statusMap = ["未提交", "未回复", "已回复"];
const dataMode = 1;
// my daily report

export function increaseDailyReportLoadCounter() {
	return dispatch => dispatch({
		type: WorkReportConstants.ActionTypes.INCREASEDAILYREPORTLOADCOUNTER,
	});
}
export function fetchDailyReportList(gets, callback = null) {
	return dispatch => dailyReportService.fetchDailyReportList(gets, res => {
		res.data.list_data.Data.forEach(data => data.status_name = statusMap[data.status]);
		dispatch({
			type: WorkReportConstants.ActionTypes.SELECTDAILYREPORTSUCCESS,
			payload: {
				data: res.data.list_data
			}
		});
	}, err => dispatch({
			type: WorkReportConstants.ActionTypes.UPDATEDAILYREPORTSTATUSSUCCESS,
			payload: {
				status: "error"
			}
		})
	);
}
export function setDailyReportFilter(filters) {
	return dispatch => dispatch({
		type: WorkReportConstants.ActionTypes.SETDAILYREPORTFILTERS,
		payload: {
			filters: filters
		}
	});
}
export function updateDailyReport(puts, index, callback = null) {
	return dispatch => dailyReportService.updateDailyReport(puts, res => {
		puts.status_name = statusMap[puts.status];
		dispatch({
			type: WorkReportConstants.ActionTypes.UPDATEDAILYREPORTSUCCESS,
			payload: {
				index: index,
				value: puts
			}
		});
		if ("function" === typeof callback) {
			callback(res.data.Success);
		}
	}, err => {});
}
export function submitDailyReport(puts, index, callback = null) {
	return dispatch => dailyReportService.submitDailyReport(puts, res => {
		puts.status_name = statusMap[puts.status];
		dispatch({
			type: WorkReportConstants.ActionTypes.UPDATEDAILYREPORTSUCCESS,
			payload: {
				index: index,
				value: puts	
			}
		});
		if ("function" === typeof callback) {
			callback(res.data.Success);
		}
	}, err => {});
}
export function updateDailyReportStatus(status = "unload") {
	return dispatch => dispatch({
		type: WorkReportConstants.ActionTypes.UPDATEDAILYREPORTSTATUSSUCCESS,
		payload: {
			status: status
		}
	});
}

// daily report management

export function increaseLeaderDailyReportLoadCounter() {
	return dispatch => dispatch({
		type: WorkReportConstants.ActionTypes.INCREASELEADERDAILYREPORTLOADCOUNTER,
	});	
}
export function fetchLeaderDailyReportList(gets, callback = null) {
	return dispatch => dailyReportService.fetchLeaderDailyReportList(gets, res => {
		// if(res.data.Success){
			res.data.list_data.Data.forEach(data => data.status_name = statusMap[data.status]);
			dispatch({
				type: WorkReportConstants.ActionTypes.SELECTLEADERDAILYREPORTSUCCESS,
				payload: {
					data: res.data.list_data	
				}
			});
		// }
		// else{
		// 	message.error(res.data.Errors);
		// 	dispatch({
		// 		type: WorkReportConstants.ActionTypes.UPDATELEADERDAILYREPORTSTATUSSUCCESS,
		// 		payload: {
		// 			status: "error"
		// 		}
		// 	})
		// }
		
	}, err => {
		dispatch({
				type: WorkReportConstants.ActionTypes.UPDATELEADERDAILYREPORTSTATUSSUCCESS,
				payload: {
					status: "error"
				}
			})
	}
	);
}
export function setLeaderDailyReportFilter(filters) {
	return dispatch => dispatch({
		type: WorkReportConstants.ActionTypes.SETLEADERDAILYREPORTFILTERS,
		payload: {
			filters: filters
		}
	});	
}

// weekly report

export function increaseWeeklyReportLoadCounter() {
	return dispatch => dispatch({
		type: WorkReportConstants.ActionTypes.INCREASEWEEKLYREPORTLOADCOUNTER,
	});
}
export function fetchWeeklyReportList(gets, callback = null) {
	return dispatch => weeklyReportService.fetchWeeklyReportList(gets, res => {
		res.data.list_data.Data.forEach(data => data.status_name = statusMap[data.status]);
		dispatch({
			type: WorkReportConstants.ActionTypes.SELECTWEEKLYREPORTSUCCESS,
			payload: {
				data: res.data.list_data
			}
		});
	}, err => dispatch({
			type: WorkReportConstants.ActionTypes.UPDATEWEEKLYREPORTSTATUSSUCCESS,
			payload: {
				status: "error"
			}
		})
	);
}
export function setWeeklyReportFilter(filters) {
	return dispatch => dispatch({
		type: WorkReportConstants.ActionTypes.SETWEEKLYREPORTFILTERS,
		payload: {
			filters: filters
		}
	});
}
export function updateWeeklyReport(puts, index, callback = null) {
	return dispatch => weeklyReportService.updateWeeklyReport(puts, res => {
		puts.status_name = statusMap[puts.status];
		dispatch({
			type: WorkReportConstants.ActionTypes.UPDATEWEEKLYREPORTSUCCESS,
			payload: {
				index: index,
				value: puts
			}
		});
		if ("function" === typeof callback) {
			callback(res.data.Success);
		}
	}, err => {});
}
export function submitWeeklyReport(puts, index, callback = null) {
	return dispatch => weeklyReportService.submitWeeklyReport(puts, res => {
		puts.status_name = statusMap[puts.status];
		dispatch({
			type: WorkReportConstants.ActionTypes.UPDATEWEEKLYREPORTSUCCESS,
			payload: {
				index: index,
				value: puts	
			}
		});
		if ("function" === typeof callback) {
			callback(res.data.Success);
		}
	}, err => {});
}
export function submitCurrentWeeklyReport(puts, index, callback = null) {
	return dispatch => weeklyReportService.submitCurrentWeeklyReport(puts, res => {
		puts.status_name = statusMap[puts.status];
		dispatch({
			type: WorkReportConstants.ActionTypes.UPDATEWEEKLYREPORTSUCCESS,
			payload: {
				index: index,
				value: puts	
			}
		});
		if ("function" === typeof callback) {
			callback(res.data.Success);
		}
	}, err => {});
}


export function updateWeeklyReportStatus(status = "unload") {
	return dispatch => dispatch({
		type: WorkReportConstants.ActionTypes.UPDATEWEEKLYREPORTSTATUSSUCCESS,
		payload: {
			status: status
		}
	});
}

// weekly report management

export function increaseLeaderWeeklyReportLoadCounter() {
	return dispatch => dispatch({
		type: WorkReportConstants.ActionTypes.INCREASELEADERWEEKLYREPORTLOADCOUNTER,
	});	
}
export function fetchLeaderWeeklyReportList(gets, callback = null) {
	return dispatch => weeklyReportService.fetchLeaderWeeklyReportList(gets, res => {
		// if(res.data.Success){
			res.data.list_data.Data.forEach(data => data.status_name = statusMap[data.status]);
			dispatch({
				type: WorkReportConstants.ActionTypes.SELECTLEADERWEEKLYREPORTSUCCESS,
				payload: {
					data: res.data.list_data	
				}
			});
		// }
		// else{
			
		// }
		
	}, err => {
		// message.error(res.data.Errors);
			dispatch({
				type: WorkReportConstants.ActionTypes.UPDATELEADERWEEKLYREPORTSTATUSSUCCESS,
				payload: {
					status: "error"
				}
			})
	}
	);
}
// 	}, err => dispatch({
// 			type: WorkReportConstants.ActionTypes.UPDATELEADERWEEKLYREPORTSTATUSSUCCESS,
// 			payload: {
// 				status: "error"
// 			}
// 		})
// 	);
// }
export function setLeaderWeeklyReportFilter(filters) {
	return dispatch => dispatch({
		type: WorkReportConstants.ActionTypes.SETLEADERWEEKLYREPORTFILTERS,
		payload: {
			filters: filters
		}
	});	
}

// my monthly report

export function increaseMonthlyReportLoadCounter() {
	return dispatch => dispatch({
		type: WorkReportConstants.ActionTypes.INCREASEMONTHLYREPORTLOADCOUNTER,
	});
}
export function fetchMonthlyReportList(gets, callback = null) {
	return dispatch => monthlyReportService.fetchMonthlyReportList(gets, res => {
		res.data.list_data.Data.forEach(data => data.status_name = statusMap[data.status]);
		dispatch({
			type: WorkReportConstants.ActionTypes.SELECTMONTHLYREPORTSUCCESS,
			payload: {
				data: res.data.list_data
			}
		});
	}, err => dispatch({
			type: WorkReportConstants.ActionTypes.UPDATEMONTHLYREPORTSTATUSSUCCESS,
			payload: {
				status: "error"
			}
		})
	)
}
export function setMonthlyReportFilter(filters) {
	return dispatch => dispatch({
		type: WorkReportConstants.ActionTypes.SETMONTHLYREPORTFILTERS,
		payload: {
			filters: filters
		}
	});
}
export function updateMonthlyReport(puts, index, callback = null) {
	return dispatch => monthlyReportService.updateMonthlyReport(puts, res => {
		puts.status_name = statusMap[puts.status];
		dispatch({
			type: WorkReportConstants.ActionTypes.UPDATEMONTHLYREPORTSUCCESS,
			payload: {
				index: index,
				value: puts
			}
		});
		if ("function" === typeof callback) {
			callback(res.data.Success);
		}
	}, err => {});
}
export function submitMonthlyReport(puts, index, callback = null) {
	return dispatch => monthlyReportService.submitMonthlyReport(puts, res => {
		puts.status_name = statusMap[puts.status];
		dispatch({
			type: WorkReportConstants.ActionTypes.UPDATEMONTHLYREPORTSUCCESS,
			payload: {
				index: index,
				value: puts	
			}
		});
		if ("function" === typeof callback) {
			callback(res.data.Success);
		}
	}, err => {});
}
export function updateMonthlyReportStatus(status = "unload") {
	return dispatch => dispatch({
		type: WorkReportConstants.ActionTypes.UPDATEMONTHLYREPORTSTATUSSUCCESS,
		payload: {
			status: status
		}
	});
}

// monthly report management

export function increaseLeaderMonthlyReportLoadCounter() {
	return dispatch => dispatch({
		type: WorkReportConstants.ActionTypes.INCREASELEADERMONTHLYREPORTLOADCOUNTER,
	});	
}
export function fetchLeaderMonthlyReportList(gets, callback = null) {
	return dispatch => monthlyReportService.fetchLeaderMonthlyReportList(gets, res => {
		// if(res.data.Success){
			res.data.list_data.Data.forEach(data => data.status_name = statusMap[data.status]);
			dispatch({
				type: WorkReportConstants.ActionTypes.SELECTLEADERMONTHLYREPORTSUCCESS,
				payload: {
					data: res.data.list_data	
				}
			});
// 		}
// 		else{
// 			message.error(res.data.Errors);
// 			dispatch({
// 				type: WorkReportConstants.ActionTypes.UPDATELEADERMONTHLYREPORTSTATUSSUCCESS,
// 				payload: {
// 					status: "error"
// 				}
// 			})
// 		}
		
// 	}, err => {}
// 	);
// }
	}, err => dispatch({
			type: WorkReportConstants.ActionTypes.UPDATELEADERMONTHLYREPORTSTATUSSUCCESS,
			payload: {
				status: "error"
			}
		})
	);
}
export function setLeaderMonthlyReportFilter(filters) {
	return dispatch => dispatch({
		type: WorkReportConstants.ActionTypes.SETLEADERMONTHLYREPORTFILTERS,
		payload: {
			filters: filters
		}
	});	
}

// template management
function changeTemplateManagementAction (filters = {}, status = "loading", counter = 1) {
	return {
		type: WorkReportConstants.ActionTypes.CHANGETEMPLATEMANAGEMENT,
		payload: {
			filters: filters,
			status: status,
			counter: counter
		}
	}
}
export function changeTemplateManagement (filters = {}, status = "loading", counter = 1) {
	return dispatch => dispatch(changeTemplateManagementAction(filters, status, counter));
}
export function selectTemplateManagement (gets, callback) {
	let apiLoadStatus = false;
	return dispatch => {
		templateManagementService.selectTemplateManagement(gets, res => {
			apiLoadStatus = true;
			if (res.data.Success || 1 === dataMode) {
				dispatch({
					type: WorkReportConstants.ActionTypes.SELECTTEMPLATEMANAGEMENT,
					payload: {
						data: res.data.Object,
						status: "loaded"
					}
				});
			}else{
				dispatch(changeTemplateManagementAction({}, "error", 0));
			}
		}, err => {
			apiLoadStatus = true;
			dispatch(changeTemplateManagementAction({}, "error", 0))
		})
		let timeoutIndex = setTimeout(() => {
			clearTimeout(timeoutIndex);
			if (!apiLoadStatus) {
				dispatch(changeTemplateManagementAction({}, "loading", 0))
			}
		}, 100);
	}
}
export function updateTemplateManagement (puts, index, callback) {
	return dispatch => templateManagementService.updateTemplateManagement(puts, res => {
		if ("function" === typeof callback) {
			callback(res);
		}
		if (res.data.Success) {
			dispatch({
					type: WorkReportConstants.ActionTypes.UPDATETEMPLATEMANAGEMENT,
					payload: {
						data: puts,
						index: index
					}
			});
		}
	})
}












// WEBPACK FOOTER //
// ./src/actions/work-report-actions.js